import { Typography } from '@mui/material';
import NavGroup from './NavGroup';
import getDashboard from 'menu-items/dashboard';
import getCustomer from 'menu-items/customer';
import salesRecord from 'menu-items/salesRecord';
import getMasterDataManagement from 'menu-items/masterDataManagement';
import getAIPackages from 'menu-items/dailyPayoutRecords';
import payoutRequest from 'menu-items/payoutRequest';
import referralDetails from 'menu-items/referralDetails';
import referralRequests from 'menu-items/referralRequests';
import getPackages from 'menu-items/package';
import expensesRecords from 'menu-items/expensesRecords';
import getUsersManagement from 'menu-items/users';
import { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { axiosInstance } from 'utils/axios';
import { selectCurrentToken } from 'features/auth/authSlice';
import { useSelector } from 'react-redux';
import getWithdrawalManagement from 'menu-items/withdrawal';
import adjustment from 'menu-items/adjustment';
import customerTransactions from 'menu-items/customerTransactions';
import salesLockRecord from 'menu-items/salesLockRecord';
import binaryIncomeDetails from 'menu-items/binaryIncomeDetails';
import sContent from 'menu-items/sContent';
import getTaskManagement from 'menu-items/tasklist';
import customerTasklist from 'menu-items/customerTaskList';
import drivers from 'menu-items/drivers';
import addresses from 'menu-items/addresses';
import approveAudio from '../../../../../src/assets/approve.mp3';
import thirdPartyReport from 'menu-items/thirdPartyReport';
import referralTeamSales from 'menu-items/referralTeamSales';
import teamIncentiveProfitDetails from 'menu-items/teamIncentiveProfitDetails';
import ambassadorClaims from 'menu-items/ambassadorClaims';
import lockSalesProfit from 'menu-items/lockSalesProfit';
import shopPurchase from 'menu-items/shopPurchase';
import payment from 'menu-items/payment';
import rankingProfit from 'menu-items/rankingProfits';
import getDeposit from 'menu-items/deposit';
import transfer from 'menu-items/transfer';
import missionClaims from 'menu-items/missionclaims';
import followUpReport from 'menu-items/followUpReport';
import ambassadorDeposit from 'menu-items/ambassadorDeposit';
import notification from 'menu-items/notification';
import earnWalletInvestment from 'menu-items/earnWalletInvestment';
import earnWalletProfit from 'menu-items/earnWalletProfit';
import earnWalletWithdrawal from 'menu-items/earnWalletWithdrawal';
import getAmbassadorLevel from 'menu-items/ambassadorLevel';
import getKYCManagement from 'menu-items/kycManagement';
import getSalesRecord from 'menu-items/salesRecord';
import getCustomerForgotPassword from 'menu-items/customerForgotPassword';


const MenuList = () => {
    const [availableMenu, setAvailableMenu] = useState([]);
    const token = useSelector(selectCurrentToken);

    const approveAudioRef = useRef(new Audio(approveAudio));

    const fetchData = useCallback(async () => {
        try {
            const res = await axiosInstance.get(`/AvailableMenu`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setAvailableMenu(res.data);
                res.data.forEach((menu) => {
                    if (menu.isRing) {
                        approveAudioRef.current.play();
                        return;
                    }
                });
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    }, [token]);

    useEffect(() => {
        fetchData();
        const interval = setInterval(() => {
            fetchData();
        }, 1000 * 60);

        return () => {
            clearInterval(interval);
        };
    }, [fetchData, token]);

    console.log(availableMenu);

    const menuItem = {
        items: availableMenu
            .filter((item) => item.active)
            .map((item) => {
                switch (item.name) {
                    case 'Dashboard':
                        return { ...getDashboard(), count: item.pendingNumber };
                    case 'Customer':
                        return { ...getCustomer(), count: item.pendingNumber };
                    case 'Notification':
                        return notification;
                    case 'Sales Record':
                        return { ...getSalesRecord(), count: item.pendingNumber };
                    case 'Master Data Management':
                        return { ...getMasterDataManagement(), count: item.pendingNumber };
                    case 'Daily Payout Records':
                        return { ...getAIPackages(), count: item.pendingNumber };
                    case 'Payout Request':
                        return { ...getCustomerForgotPassword(), count: item.pendingNumber };
                    case 'Ambassador Deposit':
                        return { ...ambassadorDeposit, count: item.pendingNumber };
                    case 'Deposit':
                        return { ...getDeposit(), count: item.pendingNumber };
                    case 'Package / Item Record':
                        return { ...getPackages(), count: item.pendingNumber };
                    case 'Expenses Records':
                        return { ...expensesRecords, count: item.pendingNumber };
                    case 'Withdrawal':
                        return { ...getWithdrawalManagement(), count: item.pendingNumber };
                    case 'Referral Details':
                        return { ...referralDetails, count: item.pendingNumber };
                    case 'Referral Request':
                        return { ...referralRequests, count: item.pendingNumber };
                    case 'Adjustment':
                        return { ...adjustment, count: item.pendingNumber };
                    case 'Customer Transactions':
                        return { ...customerTransactions, count: item.pendingNumber };
                    case 'Sales Lock Records':
                        return { ...salesLockRecord, count: item.pendingNumber };
                    case 'Binary Income Details':
                        return { ...binaryIncomeDetails, count: item.pendingNumber };
                    case 'S Content':
                        return { ...sContent, count: item.pendingNumber };
                    case 'Tasklist Management':
                        return { ...getTaskManagement(), count: item.pendingNumber };
                    case 'Customer Tasklist Management':
                        return { ...customerTasklist, count: item.pendingNumber };
                    case 'Users':
                        return { ...getUsersManagement(), count: item.pendingNumber };
                    case 'Drivers':
                        return { ...drivers, count: item.pendingNumber };
                    case 'Addresses':
                        return { ...addresses, count: item.pendingNumber };
                    case 'Third Party Report':
                        return { ...thirdPartyReport, count: item.pendingNumber };
                    case 'Referral Team Sales':
                        return referralTeamSales;
                    case 'Team Incentive Profit':
                        return teamIncentiveProfitDetails;
                    case 'Ambassador Claims':
                        return ambassadorClaims;
                    case 'Lock Sales Profit':
                        return lockSalesProfit;
                    case 'Shop Purchase':
                        return { ...shopPurchase, count: item.pendingNumber };
                    case 'Payment':
                        return { ...payment, count: item.pendingNumber };
                    case 'Ranking Profit':
                        return { ...rankingProfit, count: item.pendingNumber };
                    case 'Transfer':
                        return { ...transfer, count: item.pendingNumber };
                    case 'Mission Claims':
                        return missionClaims;
                    case 'Follow Up Report':
                        return followUpReport;
                    case 'Earn Wallet Investment':
                        return earnWalletInvestment;
                    case 'Earn Wallet Profit':
                        return earnWalletProfit;
                    case 'Earn Wallet Withdrawal':
                        return earnWalletWithdrawal;
                    case 'Ambassador Level':
                        return { ...getAmbassadorLevel(), count: item.pendingNumber };
                    case 'KYC Management':
                        return { ...getKYCManagement(), count: item.pendingNumber };
                    default:
                        return null;
                }
            })
    };

    // Use useMemo to memoize the navItems array
    const navItems = useMemo(() => {
        return menuItem.items.map((item) => {
            // console.log(item)
            if (item) {
                switch (item.type) {
                    case 'group':
                        return <NavGroup key={item.id} item={{ ...item, count: item.count }} />;
                    default:
                        return (
                            <Typography key={item.id} variant="h6" color="error" align="center">
                                Menu Items Error
                            </Typography>
                        );
                }
            }
            return null; // Handle the case where item is null
        });
    }, [menuItem.items]);

    return <>{navItems}</>;
};

export default MenuList;
